.root {
  position: relative;
  display: grid;
  gap: 28px;
}

.pressReleaseRoot {
  @container press-release-root (min-width: 1024px) {
    gap: 32px;

    .root2015 {
      width: 718px;
    }
  }
}

.screen {
  @media screen and (width >= 1024px) {
    gap: 32px;

    .root2015 {
      width: 718px;
    }
  }
}
